(function () {
    // initialise filters
    let diagnosis = localStorage.getItem('dat_diagnosis'),
        whytaken = localStorage.getItem('dat_whytaken'),
        fertilitypreferences = localStorage.getItem('dat_fertilitypreferences'),
        age = localStorage.getItem('dat_age'),
        administration = localStorage.getItem('dat_administration'),
        location = localStorage.getItem('dat_location'),
        frequency = localStorage.getItem('dat_frequency'),
        stageofcondition = localStorage.getItem('dat_stageofcondition'),
        medicinetype = localStorage.getItem('dat_medicinetype'),
        compareList = localStorage.getItem('dat_comparelist');
    diagnosis = (diagnosis === null) ? '' : diagnosis;
    whytaken = (whytaken === null) ? 'For long-term use' : whytaken;
    fertilitypreferences = (fertilitypreferences === null) ? '' : fertilitypreferences;
    age = (age === null) ? '' : age;
    administration = (administration === null) ? [] : administration.split(',');
    location = (location === null) ? [] : location.split(',');
    frequency = (frequency === null) ? [] : frequency.split(',');
    stageofcondition = (stageofcondition === null) ? [] : stageofcondition.split(',');
    medicinetype = (medicinetype === null) ? [] : medicinetype.split(',');
    compareList = (compareList === null || compareList === '') ? [] : compareList.split(',');

    // Helper functions ----------------
    // handles ticking/unticking checkboxes when No Preferences is selected
    const toggleNoPrefs = function (chks) {
        if (chks.length > 0) {
            if (chks[chks.length - 1] === '') {
                // No Prefs was just ticked, so untick all except No Prefs
                chks = [''];
            }
            else {
                // other checkboxes have since been ticked, so untick No Prefs
                let idx = chks.indexOf('');
                if (idx > -1) {
                    chks.splice(idx, 1);
                }
            }
        }
        //otherwise just tick the No Prefs option
        else chks = [''];

        return chks;
    };

    // App ------------------------------
    // Listing app
    const Listing = Vue.createApp({
        data() {
            return {
                //defaults
                matchingResults: [],
                excludedOptions: [],
                compareList: compareList,
                diagnosis: diagnosis,
                whytaken: whytaken,
                fertilitypreferences: fertilitypreferences,
                age: age,
                administration: administration,
                location: location,
                frequency: frequency,
                stageofcondition: stageofcondition,
                medicinetype: medicinetype,
                filtersPopUp: {
                    medicinePurpose: "",
                    diagnosis: "",
                    fertilityPreferences: "",
                    howItIsTaken: "",
                    age: "",
                    medicineType: "",
                    diseaseStage: "",
                    whereItIsTaken: "",
                    howOftenIsItTaken: ""
                }
            };
        },

        mounted() {
            const map = {
                medicinePurposeInfo: "medicinePurpose",
                diagnosisInfo: "diagnosis",
                fertilityPreferencesInfo: "fertilityPreferences",
                howItIsTakenInfo: "howItIsTaken",
                ageInfo: "age",
                medicineTypeInfo: "medicineType",
                diseaseStageInfo: "diseaseStage",
                whereItIsTakenInfo: "whereItIsTaken",
                howOftenIsItTakenInfo: "howOftenIsItTaken"
            };

            Object.keys(map).forEach(prop => {
                $.get(`/umbraco/api/decisionaidtoolapi/getinfopopupcontent?prop=${prop}`, data => {
                    console.log("Popup API:", prop, data);
                    this.filtersPopUp[map[prop]] = data;
                });
            });
        },

        created() {
            this.fetchResults();
        },

        methods: {
            resetFilters() {
                const t = this;
                t.diagnosis = '';
                t.whytaken = 'For long-term use';
                t.fertilitypreferences = '';
                t.age = '';
                t.administration = [];
                t.location = [];
                t.frequency = [];
                t.stageofcondition = [];
                t.medicinetype = [];
                this.fetchResults();
            },

            checkIsFiltered() {
                const t = this;
                const hasSelections = (chks) => chks.length > 0 && chks[0] !== '';
                return (t.whytaken.length + t.diagnosis.length + t.age.length) > 0 ||
                    hasSelections(t.fertilitypreferences) ||
                    hasSelections(t.administration) ||
                    hasSelections(t.location) ||
                    hasSelections(t.frequency) ||
                    hasSelections(t.stageofcondition) ||
                    hasSelections(t.medicinetype);
            },

            removeExcludedFromCompare() {
                const t = this;
                let cl = t.compareList;
                for (let i = 0; i < cl.length; i++) {
                    const id = cl[i];
                    if (t.excludedOptions.some(c => String(c?.Id) === id)) {
                        cl.splice(cl.indexOf(id), 1);
                        i--;
                    }
                }
            },

            fetchResults() {
                const t = this;
                t.administration = toggleNoPrefs(t.administration);
                t.location = toggleNoPrefs(t.location);
                t.frequency = toggleNoPrefs(t.frequency);
                t.stageofcondition = toggleNoPrefs(t.stageofcondition);
                t.medicinetype = toggleNoPrefs(t.medicinetype);

                const qs = `diagnosis=${t.diagnosis}&whytaken=${t.whytaken}&fertilitypreferences=${t.fertilitypreferences}&age=${t.age}&administration=${t.administration}&location=${t.location}&frequency=${t.frequency}&stageofcondition=${t.stageofcondition}&medicinetype=${t.medicinetype}`;
                t.navigate(qs);
                t.checkIsFiltered();

                localStorage.setItem('dat_diagnosis', t.diagnosis);
                localStorage.setItem('dat_whytaken', t.whytaken);
                localStorage.setItem('dat_fertilitypreferences', t.fertilitypreferences);
                localStorage.setItem('dat_age', t.age);
                localStorage.setItem('dat_administration', t.administration);
                localStorage.setItem('dat_location', t.location);
                localStorage.setItem('dat_frequency', t.frequency);
                localStorage.setItem('dat_stageofcondition', t.stageofcondition);
                localStorage.setItem('dat_medicinetype', t.medicinetype);
            },

            navigate(qs) {
                const t = this;
                $.getJSON(`/umbraco/api/decisionaidtoolapi/getresults?${qs}`, function (data) {
                    console.log("API result:", data);
                    t.matchingResults = data.matchingResults;
                    t.excludedOptions = data.excludedOptions;
                    t.removeExcludedFromCompare();
                }).then(function () {
                    t.checkCompare();
                });
            },

            checkCompare() {
                const cl = this.compareList;
                if (cl.length > 3) {
                    cl.pop();
                } else if (cl.length === 3) {
                    UIkit.tooltip('.compare-bar-checkbox', { title: '' });
                    UIkit.tooltip('.unchecked-compare-bar', {
                        title: 'You can compare a maximum of three medicines. You already have three medicines selected. Please deselect a medicine to add this to your comparison.',
                        pos: 'top-left'
                    });
                } else {
                    UIkit.tooltip('.compare-bar-checkbox', { title: '' });
                    UIkit.tooltip('.unchecked-compare-bar', { title: '' });
                }
                localStorage.setItem('dat_comparelist', cl);
            },

            isChecked(medicineId) {
                return this.compareList.includes(medicineId.toString())
            },

            goToComparison() {
                const cl = localStorage.getItem('dat_comparelist').split(',');
                if (cl.length > 1) {
                    document.location.href = `medicine-tool/comparison-results`;
                }
            },

            showModal(prop, medicineId) {
                // Find the medicine in either matching or excluded options
                const medicine = this.matchingResults.find(m => m.id === medicineId)
                    || this.excludedOptions.find(m => m.id === medicineId);
                if (!medicine) return;

                // Use the first alias as the modal title (if available)
                const title = (medicine.otherNames && medicine.otherNames.length > 0)
                    ? medicine.otherNames[0]
                    : medicine.name;

                // Fetch content for the clicked medicine
                $.get(`/umbraco/api/decisionaidtoolapi/getinfopopupcontent?prop=${prop}&nid=${medicineId}`, data => {
                    $('#info-modal-title').text(title);
                    $('#info-popup-content').html(data);
                    UIkit.modal(document.getElementById('info-modal')).show();
                });
            }

        }
    });
    const vm = Listing.mount('#listing');
})();


String.prototype.toSentenceCase = function () {
    return this.charAt(0).toUpperCase() + this.substr(1).toLowerCase();
};